import { render, staticRenderFns } from "./ChildrenCategoryModal.vue?vue&type=template&id=85ee02ae&scoped=true&"
import script from "./ChildrenCategoryModal.vue?vue&type=script&lang=js&"
export * from "./ChildrenCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ee02ae",
  null
  
)

export default component.exports